import React from 'react';
import { Tabs, Typography, Card, Collapse } from 'antd';
import map from 'assets/img/map.png';

const { TabPane } = Tabs;
const { Title, Text, Paragraph } = Typography;
const { Panel } = Collapse;

const terms = [
  {
    title: 'Taxes & Munis',
    body: [
      {
        title: "Assessor's Card",
        text: "We obtain and provide a copy of the assessor's card from the Assessor's Office. The information on the card should include the date of construction, assessed valuation, owner of record, and/ or other pertinent information.",
      },
      {
        title: 'Articles of Organization',
        text: 'Articles of Organization',
      },
      {
        title: 'Air Resources Information Search',
        text: 'NYC only: A search to determine if violations exist with the Department of Air Resources. The report includes the current status of fuel burning and compacting equipment.',
      },
      {
        title: 'Building History Report',
        text: 'NYC only: We search for and document Building Department records to determine the exact timeline of alterations and improvements for a given building.',
      },
      {
        title: 'Certificate of Occupancy Search',
        text: "We create and provide an abstract of building department records reporting all Certificates of Occupancy, Certificates of Compliance/Completion, and all open building permits. We include copies of all certificates found. If no Certificate of Occupancy is on file, the abstract will include information from other municipal agencies and the Assessor's Office regarding the structure(s), the use and the approximate year the structure was erected. In NYC, we provide a copy of the last CO of record, plus any subsequent plans filed that either change or propose to change the legal use.",
      },
      {
        title: 'Copy / Review of Plans',
        text: 'We obtain a copy of the building plans as maintained by the Building Department and, if requested, provide a review to identify any specific structures.',
      },
      {
        title: 'Division of Housing and Renewal Search',
        text: 'AKA Rent Roll. NYC only: We search for and document if units in a building are subject to rent control and/or rent stabilization. All reports are certified by the New York State - Division of Housing Community Renewal. (A copy of deed and a letter of authorization must be supplied by the owner.) ',
      },
      {
        title: 'Dwelling Search Report ',
        text: 'Dwelling Search Report ',
      },
      {
        title: 'Emergency Repairs Violation Search',
        text: 'We search for and document any repairs or services provided to said property of an emergency nature where property owner was negligent in responding shown in the municipal records of the appropriate municipality.',
      },
      {
        title: 'Fire Violations Search',
        text: "We search for and report on any violations of record with the Fire Department's local and/or central files.",
      },
      {
        title: 'Locate Survey',
        text: 'We obtain and provide a copy of the latest available guaranteed and/or certified survey from the Building Department. If no guaranteed or certified survey is on file, we provide the most recent survey available instead.',
      },
      {
        title: 'Flood Zone Search',
        text: 'We provide you with a Flood Zone Report or a Flood Zone Hazard Certification, using the Federal Flood Insurance Rate Maps to determine the classification of the particular site in question.',
      },
      {
        title: 'Gas and Electric Violation Search',
        text: 'NYC only: We search for and document any recorded violations regarding wiring, gas leakage, etc.',
      },
      {
        title: 'Housing and Building Violation Search',
        text: 'AKA Building Violation Search. We search for and document all pending violations of the local building code and in NYC, the New York State  Multiple Dwelling Law, found at the Housing Department and Building Department.',
      },
      {
        title: 'Health Department Violation Search',
        text: 'We search for and report on all violations found at the Health Department.',
      },
      {
        title: 'Highway / Sidewalk Violation Search',
        text: 'We search for and document any outstanding sidewalk violations. (Please note that this does not provide street maintenance information.)',
      },
      {
        title: 'Landmark Search',
        text: 'We provide a report showing if the property is a designated landmark or within a historic district. In New York City, this will include any violation information found.',
      },
      {
        title: 'Tax Lien Satisfaction Letter',
        text: 'We obtain and provide a letter indicating that a specified tax lien has been satisfied.',
      },
      {
        title: 'Multiple Dwelling Registration Card',
        text: 'NYC only: We provide a report indicating the legality of the property.',
      },
      {
        title: 'Miscellaneous Departmental Request',
        text: 'If no other available search seems to include for the departmental information you are looking for, please use this to request what you need.',
      },
      {
        title: 'Fuel Oil Search',
        text: 'AKA Fuel Oil Permit Search. NYC only: A search of Fire Department records for any existing Fuel Oil Permit, including the permit number, capacity of the current oil tank and current status of the annual fee.',
      },
      {
        title: 'Pest Control Violation Search',
        text: 'NYC only: We search for and document violations regarding pest control recorded with the NYC Health Department.',
      },
      {
        title: 'Photo Property Inspection',
        text: 'We conduct an exterior walkaround, take photos of pertinent features, and provide copies of those photos.',
      },
      {
        title: 'Tax Lien Payoff',
        text: 'We obtain and provide a report which indicates the amount due to satisfy a tax lien.',
      },
      {
        title: 'Patriot Search',
        text: 'A search to determine if an individual or business are included on the Specially Designated Nationals & Block Persons" list issued by President Bush under Executive Order 13224. (There is a fee per name.)',
      },
      {
        title: 'Survey Inspection with Photos',
        text: 'We conduct an on-site inspection to determine any apparent physical changes to the existing structure(s), possible encroachments and the addition of new structure(s) as compared to the survey supplied. We also conduct an exterior walkaround, take photos of pertinent features, and provide copies of those photos.',
      },
      {
        title: 'Quick Tax Search',
        text: 'A handwritten/printout report indicating current tax information without water charges.The amounts due, including arrears is provided.',
      },
      {
        title: 'Sanborn Map',
        text: 'NYC only: We obtain and provide a copy of the requested Sanborn or Belcher Hyde Map.',
      },
      {
        title: 'Street Report',
        text: 'NYC only: We search for and document the current street width, and report on any applications for street widening on file at the Highway Department.',
      },
      {
        title: 'Street Maintenance Report',
        text: 'We search for and document the party responsible for street maintenance.',
      },
      {
        title: 'Survey Inspection',
        text: 'We conduct an on-site inspection to determine any apparent physical changes to the existing structure(s), possible encroachments and the addition of new structure(s) as compared to the survey supplied.',
      },
      {
        title: 'Sewer Report',
        text: 'Nassau County: A search to determine if a property conforms to the Department of Public Works Ordinance #266 of the Public Health Ordinance of Nassau County, which mandates all properties within the Nassau County Sewer District be connected to said sewer within one year of official notice. Suffolk County: This search indicates whether or not the property is located within a Municipal Sewer District. If the property does in fact lie within the district, the search will indicate the amount due.',
      },
      {
        title: "Tax Assessor's Letter",
        text: "We obtain a letter based provided by the Assessor's Office which may include the date of construction, assessed valuation, record owner and/or other pertinent information.",
      },
      {
        title: 'Tax Bill',
        text: 'We obtain and provide a copy of the current tax bill.',
      },
      {
        title: 'Tax Search Continuation',
        text: 'We provide a continuation of an already completed Tax Search.',
      },
      {
        title: 'Tax Figure Report',
        text: 'We provide a report indicating the most current tax figures for a specific tax year for a parcel.',
      },
      {
        title: 'Tax History Report',
        text: 'NYC only: We provide a NYC Department of Finance printout with current information by tax borough block and lot. The tax history contains such information as real estate tax, frontage meter charges and other tax assessments. It will further indicate whether assessments are open or paid. If paid, payment information including pay date is provided. It will also show (if applicable) over-payments, credits, cancellation of assessments, abatement info, lien info, etc.',
      },
      {
        title: 'Tax Search With Interest',
        text: 'We search for and report on county and local tax records to ascertain the existence of arrears, tax liens and to determine the current status of payments.',
      },
      {
        title: 'Tideland Search',
        text: 'Tideland Search',
      },
      {
        title: 'Miscellaneous Tax Search',
        text: 'If no other available tax search seems to include for the tax information you are looking for, please use this to request what you need.',
      },
      {
        title: 'Tax Payment',
        text: 'NYC only: Barretta Realty Skyline can make payments of current and past due taxes (including S.C.R.I.E. taxes, restored taxes, etc.) Tax lien sale payments are also available.',
      },
      {
        title: 'Tax Search',
        text: 'We search for and report on county and local tax records to ascertain the existence of arrears, tax liens and to determine the current status of payments.',
      },
      {
        title: 'Underground Storage Permit Search',
        text: 'NYC only: We search for and document any underground fuel storage containment on the property. Normally this is associated with commercial property such as a gas station.',
      },
      {
        title: 'Vault Tax Search',
        text: 'NYC only: A report indicating the taxes on the vault of a property. A vault is considered any underground storage which physically goes underneath a street rather than under a building. (While this tax has been done away with as of 1997/1998, there may be older outstanding charges.)',
      },
      {
        title: 'Water Tax Bill',
        text: 'NYC only: We provide a copy of the current water tax bill.',
      },
      {
        title: 'Wetland Search',
        text: 'Wetland Search',
      },
      {
        title: 'Water Payment',
        text: 'NYC only: Barretta Realty Skyline can make payments in NYC to the Department of Environmental Protection for current or outstanding water charges.',
      },
      {
        title: 'Zoning Report',
        text: 'We provide a report showing zoning classifications of a tax lot and a brief description of said classification.',
      },
    ],
  },
  {
    title: 'Abstract Reports',
    body: [
      {
        title: 'Abstract of Foreclosure Action',
        text: 'We obtain and abstract the complete record of a specified foreclosure action.',
      },
      {
        title: 'Air Rights Search',
        text: 'We search for and report on the ownership of the air space over the lot(s). (There is a fee per lot.)',
      },
      {
        title: "Attorney's Search",
        text: 'We search for and document the last owner and deed-chain covering 2 years or when they encounter the last good-deed of record, whichever comes first. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Back-chain Title Examination',
        text: 'BRS will provide a complete title back-chain. This search will confirm title into the last know grantor/grantee (or the first known Acris grantor in the four Acris counties). It will include all deeds, open mortgages, abstracted surrogate proceedings, easements covenants, and restrictions, found within the back-chain timeframe',
      },
      {
        title: 'Business Certificate Search',
        text: "AKA - DBA Certificate Search. We search for and document any business certificates on file with the County's Clerks Office. (This does not search state-level records for LLC's.)",
      },
      {
        title: 'Building Loan Search',
        text: 'We search for and document any open construction/building loans, noting names, amounts and dates.',
      },
      {
        title: 'Recording Correction Request (Block & Lot)',
        text: 'This is to request a re-recording of a document following an erroneous original recording.',
      },
      {
        title: 'Copy of Certified Document Request',
        text: 'We obtain and provide a certified copy of the requested document, certified by the issuing municipality.',
      },
      {
        title: 'Civil Court Search',
        text: 'We search for and report on any Civil Court violations.',
      },
      {
        title: 'Copy of Document Request',
        text: 'We obtain and provide a copy of the requested document, found in the identified book/reel/volume.',
      },
      {
        title: 'Copy of Filing Request',
        text: 'We obtain and provide a copy of the requested document, found in the identified book/reel/volume.',
      },
      {
        title: 'CO-OP Search (For Proprietary Leasehold Insurance)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations, as well as any covenants & restrictions on the property from the time the cooperative was formed. We can provide copies of findings upon request.',
      },
      {
        title: 'Co-Operative Search Follow-Up',
        text: 'This is used to request additional information or services for an already completed search on a co-operative building or unit',
      },
      {
        title: 'CO-OP Title Search (Regular)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations. We provide copies of the last deed of record along with any UCC violations found. We can provide copies of other findings upon request. This search includes one free continuation if ordered within 6 months.',
      },
      {
        title: 'CO-OP Title Search (Reissue)',
        text: 'We search for and document the last owner and deed of record into the Cooperative on the identified closing title report we are reissuing from, or starting from a specified date. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations. We provide copies of the last deed of record along with any UCC violations found. We can provide copies of other findings upon request.',
      },
      {
        title: 'Current Owner Search ',
        text: 'Current Owner Search ',
      },
      {
        title: 'CO-OP Title Search (Limited Liability With Tax)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and all liens and bankruptcies against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. The search includes a check for state- and county-level UCC violations. We also search for and report on county and local tax records to ascertain the existence of arrears, tax liens and to determine the current status of payments. We provide copies of the last deed of record along with any UCC violations found along with the typed report. We can provide copies of other findings upon request.',
      },
      {
        title: 'CO-OP Title Search (Limited Liability Without Tax)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and all liens and bankruptcies against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. The search includes a check for state- and county-level UCC violations. We provide copies of the last deed of record along with any UCC violations found along with the typed report. We can provide copies of other findings upon request.',
      },
      {
        title: 'Covenants and Restrictions Search',
        text: 'We search for and document any property covenants/restrictions on file. ',
      },
      {
        title: 'Title Search Continuation (Not our search)',
        text: 'We provide a continuation of a title search where the original search was not done by BARRETTA REALTY SKYLINE.',
      },
      {
        title: 'Condominium Unit Search',
        text: 'We search for and document the last owner and deed-chain covering the Condominium Unit under examination. We report on all open mortgages and liens against the unit and against any name searched. We also search for covenants, restrictions and easements against the unit within the time frame of the search. We can provide copies upon request.',
      },
      {
        title: 'Cover Record',
        text: 'Cover Record',
      },
      {
        title: 'Cover Record Standalone ',
        text: 'Cover Record Standalone ',
      },
      {
        title: 'Deed and Lease Chain Report',
        text: 'We search for and document the history of recorded deed instruments for the specified property. This search covers the last 40 years or until a deed showing good consideration is found, whichever goes farther back in time.',
      },
      {
        title: 'Document Retrieval Request',
        text: 'We obtain, and provide a copy of the requested document.',
      },
      {
        title: 'Environmental Lien Search (from 1982)',
        text: 'We search for and document the history of recorded deed instruments for the specified property back to the year 1982 and provide it along with a copy of the last deed of record. We also document whether and where any Environmental Covenants and Restrictions are discovered during the search.',
      },
      {
        title: 'Environmental Lien Search (from 1940)',
        text: 'We search for and document the history of recorded deed instruments for the specified property back to the year 1940 and provide it along with a copy of the last deed of record. We also document whether and where any Environmental Covenants and Restrictions are discovered during the search.',
      },
      {
        title: 'Federal Court Search',
        text: 'We search for and document any violations on file within the Federal Courts system.',
      },
      {
        title: 'Foreclosure Search',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Foreclosure Search with Reading',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Foreclosure Search with Upper Court Search',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Full Reading Commitment',
        text: 'Full Reading Commitment',
      },
      {
        title: 'Full Title Reading',
        text: 'We examine the results of a title search covering 40 or more years, and provide a report detailing all potential exceptions for title insurance, covering but not limited to: open mortgages, liens vs. the premises, judgments and/or liens vs. the current owners and purchasers, returns against prior owners within the last 10 years, covenants and restrictions vs. the property, and any other clearance issues. The report includes information about the last title insurer if available.',
      },
      {
        title: 'Full Title Search',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Full Title Search 20 years',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Full Title Search 30 years',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Full Title Search 40 years',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Full Title Search 60 years',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Grantor/Grantee or Mortgagor/Mortgagee Report',
        text: 'AKA REO Search. We search for and document all open mortgages and real estate owned by the specified name.',
      },
      {
        title: 'Hazardous Waste Violation Search',
        text: 'We search for and document any hazardous waste violations.',
      },
      {
        title: 'Last Deed of Record',
        text: 'We search for and document the last deed of record, and provide a copy of the deed if fouond.',
      },
      {
        title: 'Litigation Search',
        text: 'We search for and document any open actions in the county courts indexes for the name searched. We also include any judgments, Federal Tax Liens, state and county-level UCC’s, and bankruptcy information. In NYC we also search for PVB and ECB records; in Richmond County we search DMV records.',
      },
      {
        title: 'Last Owner Report (Mortgages & Liens)',
        text: 'We search for and document the last owner of record, and any open mortgages and liens.',
      },
      {
        title: 'Last Owner and Mortgages Report',
        text: 'We provide a report showing the last owner of record and any open mortgages (no lien information included.)',
      },
      {
        title: 'Last Owner, Lis Pendens, In-Rem, and Surrogates',
        text: 'We search for and report on the last deed of record, verifying that the last deed is the current owner of the specified premises. We also check for any Lis Pendens, In-Rem proceedings, and Surrogate Court records affecting the premises or any grantees.',
      },
      {
        title: 'Lis Pendens Search',
        text: 'We search for and report on any recorded notifications of pending litigation regarding the identified property or any name searched. This includes providing a copy of the current minutes of the action.',
      },
      {
        title: 'Filed Lien Search (no mortgages/recorded liens)',
        text: 'We search for and report on any open filed liens against the identified property or any name searched, including Mechanic’s Liens, and any Lis Pendens found. (To receive a report detailing recorded liens, order a Last Owner, Mortgages, and Liens search.)',
      },
      {
        title: 'Miscellaneous Real Property Request',
        text: 'If no other available search seems to include for the real property information you are looking for, please use this to request what you need.',
      },
      {
        title: "Mechanic's Lien Search",
        text: "We search for and report on any Mechanic's Liens found filed against the property being searched.",
      },
      {
        title: 'Real Property Follow-Up',
        text: 'This search item is used to request a follow-up on a recently completed real property search.',
      },
      {
        title: 'Open Mortgage Search',
        text: 'This search item is used to request a follow-up on a recently completed real property search.',
      },
      {
        title: 'RedVision-Certified Document Request',
        text: 'We obtain and provide a certified copy of the requested document, certified by a Barretta Realty Skyline attorney.',
      },
      {
        title: 'Refinance Examination (w Covenants & Restrictions)',
        text: 'We search for and document the last owner and deed-chain covering the last 2 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants and restrictions against the property. We can provide copies upon request.',
      },
      {
        title: 'Refinance Search',
        text: 'We search for and document the last owner and deed-chain covering the last 2 years. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Reissue Examination',
        text: 'We search for and document the last owner and deed-chain based on the identified closing title report we are reissuing from, or starting from a specified date. Open mortgages and liens against the property and against any name searched that are found within the search are reported. We can provide copies upon request.',
      },
      {
        title: 'Real Estate Owned',
        text: 'We search for and document the last owner and deed-chain covering a minimum of the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We also include an abstract of the pending or completed foreclosure proceeding is applicable . We can provide copies upon request.',
      },
      {
        title: 'REO Commitment Report',
        text: 'REO Commitment Report',
      },
      {
        title: 'Recorded Document Search',
        text: 'We search for and verify the proper recording of an identified instrument.',
      },
      {
        title: 'Refinance Reading Commitment ',
        text: 'Refinance Reading Commitment ',
      },
      {
        title: 'Reading for Refinance Exam',
        text: 'We examine the results of a title search and provide a report detailing all potential exceptions for title insurance for a refinance transaction, covering but not limited to: open mortgages, liens vs. the premises, judgments and/or liens vs. the current owners and purchasers, returns against prior owners within the last 10 years, and any other clearance issues. The report includes information about the last title insurer if available.',
      },
      {
        title: 'Single and Separate Search',
        text: 'We search for and determine if the current lot was originally a part of a larger lot (apportioned into separate lots), or the lot was formed by combining other lots (merged into a single lot.) We provide information for all adjoining lots in addition to the target lot. We provide deed chains for all lots searched.',
      },
      {
        title: 'Surrogates Court Search',
        text: 'We search for and document any information from the appropriate surrogates file.',
      },
      {
        title: 'Second Mortgage Search',
        text: 'We search for and document the last owner and deed-chain starting at the identified recorded first mortgage. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Stub Search',
        text: 'We search for and document any open or satisfied bank mortgages. If no bank mortgages are found, a more thorough search is initiated.',
      },
      {
        title: 'Short-to-Full Exam',
        text: 'This is used to request a real property exam upgrade from short length to full length.',
      },
      {
        title: 'Survey Reading',
        text: 'We examine the provided survey and provide a report detailing the strutures and items noted on the premises. Please request affirmative insurance language as needed. If the reading requires a new survey inspection, please order that separately.',
      },
      {
        title: 'Transit Adjudication Bureau Violation Search',
        text: 'NYC Only: We search for and report on violations recorded with the NYC Taxi and Limo Commission. In Richmond County, this is a check with the Department of Motor Vehicles instead. (There is a fee per name.)',
      },
      {
        title: 'Two Owner Search with C & R (Mortgage & Liens)',
        text: 'Two Owner Search with C & R (Mortgage & Liens)',
      },
      {
        title: 'Ten-Year Examination',
        text: 'We search for and document the last owner and deed-chain covering the last 10 years. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Ten-Year Examination (w Covenants & Restrictions)',
        text: 'We search for and document the last owner and deed-chain covering the last 10 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants and restrictions against the property. We can provide copies upon request.',
      },
      {
        title: 'Two Owner Search (Mortgage & Liens)',
        text: 'Two Owner Search (Mortgage & Liens)',
      },
      {
        title: 'Real Property Exam Update (up to 11 months)',
        text: 'An update to a title report where the original request is between 3 and 11 months old.',
      },
      {
        title: 'Real Property Exam Update (12 - 23 months)',
        text: 'An update to a title report where the original request is between 12 and 23 months old. (Searches more than 2 years old cannot be updated and requires a new report.)',
      },
    ],
  },
  {
    title: 'Name Searches',
    body: [
      {
        title: 'Bankruptcy Search',
        text: 'A search of available, computerized Federal Bankruptcy Court records for both individual and/or corporate names. (There is a fee per name.)',
      },
      {
        title: 'Certificate of Incorporation',
        text: 'We search for and provide a copy of the Certificate of Incorporation filed with the New York State Department’s Division of Corporations for the name searched. (For LLC’s, this is known as Articles of Organization. There is a fee per name.)',
      },
      {
        title: 'County Judgment Search',
        text: 'County Judgment Search',
      },
      {
        title: 'Certificate of Compliance',
        text: 'Certificate of Compliance',
      },
      {
        title: 'Corporate Status Report',
        text: 'Corporate Status Report',
      },
      {
        title: 'Environmental Control Board Lien Search',
        text: 'NYC only: A search revealing any liens in default of judgment status, including liens with various New York City agencies. (There is a fee per name.)',
      },
      {
        title: 'NYS Entity Search',
        text: "We create and provide an Enitity Status Report for the name given, which includes the entity's name, address, type, status, county in which conducting business, state of jurisdiction, the date of the filing and the registered agent if any. (There is a fee per name.)",
      },
      {
        title: 'Franchise Tax Search',
        text: 'We search to see if there are any outstanding taxes owed on a corporation.  This only applies to companies with direct written premiums who must file and pay tax for all or part of each calendar/fiscal year. (There is a fee per name.)',
      },
      {
        title: 'Certificate of Good Standing Search',
        text: 'AKA Certificate of Existence. This certificate will show that your company/corporation is in "good standing", meaning all required reports have been filed and registration fees have been paid as of the date the certificate has been issued. Also, to officially prove that your company has not been suspended or cancelled.',
      },
      {
        title: 'Good Standing LLC Long Form',
        text: 'Good Standing LLC Long Form',
      },
      {
        title: 'Good Standing LLC Short Form',
        text: 'Good Standing LLC Short Form',
      },
      {
        title: 'Good Standing Certificate Short Form',
        text: 'Good Standing Certificate Short Form',
      },
      {
        title: 'Litigation Search',
        text: 'We search for and document any open actions in the county courts indexes for the name searched. We also include any judgments, Federal Tax Liens, state and county-level UCC’s, and bankruptcy information. In NYC we also search for PVB and ECB records; in Richmond County we search DMV records.',
      },
      {
        title: 'Name Run',
        text: 'We search for and document any outstanding liens against any name searched in the specified county. This includes a search for recorded judgments and Federal Tax Liens. In the boroughs of NYC we also include searches of the City’s Parking Violations Bureau (PVB) and Environmental Control Board (ECB) records. (There is a fee per name.)',
      },
      {
        title: 'Name Run with County UCC',
        text: 'We search for and document any outstanding liens against any name searched in the specified county. This includes a search for recorded judgments, county-level UCC violations, and Federal Tax Liens. In the boroughs of NYC we also include searches of the City’s Parking Violations Bureau (PVB) and Environmental Control Board (ECB) records. We provide copies of anything found. (There is a fee per name.)',
      },
      {
        title: 'Patriot Search',
        text: 'A search to determine if an individual or business are included on the Specially Designated Nationals & Block Persons" list issued by President Bush under Executive Order 13224. (There is a fee per name.)',
      },
      {
        title: 'Parking Violations Bureau Violations Search',
        text: 'NYC only: We search the NYC Parking Violations Bureau records and document any outstanding violations against the names searched. Note that there are no PVB records for Richmond County. (There is a fee per name.)',
      },
      {
        title: 'State UCC Search and FTL Search',
        text: 'A search of state records to determine if claims have been filed with New York State against collateral which an applicant pledges on a loan. (There is a fee per name.)',
      },
      {
        title: 'UCC Search (County)',
        text: 'A search of county records to determine if claims have been filed against collateral which an applicant pledges on a loan. (There is a fee per name.)',
      },
      {
        title: 'UCC Search State Certified',
        text: 'UCC Search State Certified',
      },
      {
        title: 'Upper Court Search',
        text: 'Upper Court Search',
      },
    ],
  },
  {
    title: 'Contins',
    body: [
      {
        title: 'Building Loan Continuation',
        text: 'An abstracted continuation of an already completed building loan search. (Normally ordered prior to each disbursement of construction funds.)',
      },
      {
        title: 'Emergency Repair Continuation',
        text: 'A continuation on an Emergency Repairs search. This is highly recommended prior to closings, especially in tenant occupied buildings during the winter.',
      },
      {
        title: 'Title Search Continuation',
        text: 'We provide a continuation of an already completed title search.',
      },
      {
        title: 'Title Search Continuation (Not our search)',
        text: 'We provide a continuation of a title search where the original search was not done by BARRETTA REALTY SKYLINE.',
      },
      {
        title: 'Tax Search Continuation',
        text: 'We provide a continuation of an already completed Tax Search.',
      },
      {
        title: 'Upper Court Continuation Search',
        text: 'NJ Upper Court Continuation Search',
      },
    ],
  },
  {
    title: 'Most Popular',
    body: [
      {
        title: 'Bankruptcy Search',
        text: 'A search of available, computerized Federal Bankruptcy Court records for both individual and/or corporate names. (There is a fee per name.)',
      },
      {
        title: 'Certificate of Occupancy Search',
        text: "We create and provide an abstract of building department records reporting all Certificates of Occupancy, Certificates of Compliance/Completion, and all open building permits. We include copies of all certificates found. If no Certificate of Occupancy is on file, the abstract will include information from other municipal agencies and the Assessor's Office regarding the structure(s), the use and the approximate year the structure was erected. In NYC, we provide a copy of the last CO of record, plus any subsequent plans filed that either change or propose to change the legal use.",
      },
      {
        title: 'Current Owner Search ',
        text: 'Current Owner Search',
      },
      {
        title: 'Emergency Repairs Violation Search',
        text: 'We search for and document any repairs or services provided to said property of an emergency nature where property owner was negligent in responding shown in the municipal records of the appropriate municipality.',
      },
      {
        title: 'Foreclosure Search with Upper Court Search',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Fire Violations Search',
        text: "We search for and report on any violations of record with the Fire Department's local and/or central files.",
      },
      {
        title: 'Full Title Search',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Housing and Building Violation Search',
        text: 'AKA Building Violation Search. We search for and document all pending violations of the local building code and in NYC, the New York State  Multiple Dwelling Law, found at the Housing Department and Building Department.',
      },
      {
        title: 'Name Run',
        text: 'We search for and document any outstanding liens against any name searched in the specified county. This includes a search for recorded judgments and Federal Tax Liens. In the boroughs of NYC we also include searches of the City’s Parking Violations Bureau (PVB) and Environmental Control Board (ECB) records. (There is a fee per name.)',
      },
      {
        title: 'Patriot Search',
        text: 'A search to determine if an individual or business are included on the Specially Designated Nationals & Block Persons" list issued by President Bush under Executive Order 13224. (There is a fee per name.)',
      },
      {
        title: 'Refinance Search',
        text: 'We search for and document the last owner and deed-chain covering the last 2 years. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Street Report',
        text: 'NYC only: We search for and document the current street width, and report on any applications for street widening on file at the Highway Department.',
      },
      {
        title: 'Street Maintenance Report',
        text: 'We search for and document the party responsible for street maintenance.',
      },
      {
        title: 'Sewer Report',
        text: 'Nassau County: A search to determine if a property conforms to the Department of Public Works Ordinance #266 of the Public Health Ordinance of Nassau County, which mandates all properties within the Nassau County Sewer District be connected to said sewer within one year of official notice. Suffolk County: This search indicates whether or not the property is located within a Municipal Sewer District. If the property does in fact lie within the district, the search will indicate the amount due.',
      },
      {
        title: 'Tideland Search',
        text: 'Tideland Search',
      },
      {
        title: 'Tax Search',
        text: 'We search for and report on county and local tax records to ascertain the existence of arrears, tax liens and to determine the current status of payments.',
      },
      {
        title: 'Upper Court Search',
        text: 'NJ Upper Court Search ',
      },
    ],
  },
  {
    title: 'Continuable Searches',
    body: [
      {
        title: "Attorney's Search",
        text: 'We search for and document the last owner and deed-chain covering 2 years or when they encounter the last good-deed of record, whichever comes first. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Building Loan Continuation',
        text: 'An abstracted continuation of an already completed building loan search. (Normally ordered prior to each disbursement of construction funds.)',
      },
      {
        title: 'CO-OP Search (For Proprietary Leasehold Insurance)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations, as well as any covenants & restrictions on the property from the time the cooperative was formed. We can provide copies of findings upon request.',
      },
      {
        title: 'CO-OP Title Search (Regular)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations. We provide copies of the last deed of record along with any UCC violations found. We can provide copies of other findings upon request. This search includes one free continuation if ordered within 6 months.',
      },
      {
        title: 'CO-OP Title Search (Reissue)',
        text: 'We search for and document the last owner and deed of record into the Cooperative on the identified closing title report we are reissuing from, or starting from a specified date. We report on all open mortgages and liens against the property and against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. We also search for all county-level UCC violations. We provide copies of the last deed of record along with any UCC violations found. We can provide copies of other findings upon request.',
      },
      {
        title: 'CO-OP Title Search (Limited Liability With Tax)',
        text: 'We search for and document the last owner and deed of record into the Cooperative. We report on all open mortgages and liens against the property and all liens and bankruptcies against any name searched. If the Cooperative includes for a leasehold, we will report the lease information. The search includes a check for state- and county-level UCC violations. We also search for and report on county and local tax records to ascertain the existence of arrears, tax liens and to determine the current status of payments. We provide copies of the last deed of record along with any UCC violations found along with the typed report. We can provide copies of other findings upon request.',
      },
      {
        title: 'Title Search Continuation',
        text: 'We provide a continuation of an already completed title search.',
      },
      {
        title: 'Title Search Continuation (Not our search)',
        text: 'We provide a continuation of a title search where the original search was not done by BARRETTA REALTY SKYLINE.',
      },
      {
        title: 'Foreclosure Search',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Foreclosure Search with Upper Court Search',
        text: 'We search for and document the last owner and deed-chain starting with the deed into the item being foreclosed. We report on all open mortgages and liens against the property and against any name searched. We provide a full copy of the mortgage or other document being foreclosed. Copies of other documents are available upon request.',
      },
      {
        title: 'Full Title Search',
        text: 'We search for and document the last owner and deed-chain covering the last 40 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants, restrictions and easements against the property. We can provide copies upon request.',
      },
      {
        title: 'Last Owner Report (Mortgages & Liens)',
        text: 'We search for and document the last owner of record, and any open mortgages and liens.',
      },
      {
        title: 'Owners & Encumbrance',
        text: 'Owners & Encumbrances',
      },
      {
        title: 'Refinance Examination (w Covenants & Restrictions)',
        text: 'We search for and document the last owner and deed-chain covering the last 2 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants and restrictions against the property. We can provide copies upon request.',
      },
      {
        title: 'Refinance Search',
        text: 'We search for and document the last owner and deed-chain covering the last 2 years. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Reissue Examination',
        text: 'We search for and document the last owner and deed-chain based on the identified closing title report we are reissuing from, or starting from a specified date. Open mortgages and liens against the property and against any name searched that are found within the search are reported. We can provide copies upon request.',
      },
      {
        title: 'Second Mortgage Search',
        text: 'We search for and document the last owner and deed-chain starting at the identified recorded first mortgage. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Stub Search',
        text: 'We search for and document any open or satisfied bank mortgages. If no bank mortgages are found, a more thorough search is initiated.',
      },
      {
        title: 'Short-to-Full Exam',
        text: 'This is used to request a real property exam upgrade from short length to full length.',
      },
      {
        title: 'Ten-Year Examination',
        text: 'We search for and document the last owner and deed-chain covering the last 10 years. We report on all open mortgages and liens against the property and against any name searched. We can provide copies upon request.',
      },
      {
        title: 'Ten-Year Examination (w Covenants & Restrictions)',
        text: 'We search for and document the last owner and deed-chain covering the last 10 years. We report on all open mortgages and liens against the property and against any name searched. We also search for all covenants and restrictions against the property. We can provide copies upon request.',
      },
      {
        title: 'Two Owner Search (Mortgage & Liens)',
        text: 'Two Owner Search (Mortgage & Liens)',
      },
      {
        title: 'Real Property Exam Update (up to 11 months)',
        text: 'An update to a title report where the original request is between 3 and 11 months old.',
      },
      {
        title: 'Real Property Exam Update (12 - 23 months)',
        text: 'An update to a title report where the original request is between 12 and 23 months old. (Searches more than 2 years old cannot be updated and requires a new report.)',
      },
    ],
  },
];

const Services: React.FC = () => {
  return (
    <Card>
      <Tabs defaultActiveKey="1" tabPosition={'left'}>
        <TabPane tab="DataTrace Services" key="1">
          <Text>
            The single-source solution: DataTrace offers the most comprehensive
            and precise collection of real estate information in the New York
            market.
          </Text>
          <Collapse accordion>
            {terms.map((item, index) => {
              return (
                <Panel header={item.title} key={index}>
                  {item.body.map((item) => {
                    return (
                      <>
                        <Title level={4}>{item.title}</Title>
                        <Paragraph>{item.text}</Paragraph>
                      </>
                    );
                  })}
                </Panel>
              );
            })}
          </Collapse>
          <Text>
            For more information on a specific search, simply click on it.
          </Text>
        </TabPane>
        <TabPane tab="Markets Covered" key="2">
          <Title level={4}>
            Abstract, Municipal, Tax and State Level Research
          </Title>
          <Text>We provide searches in all 62 counties in New York:</Text>
          <Card size="small">
            <img src={map} alt="" />
          </Card>
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default Services;
